<template>
  <!-- 字段显隐 -->
  <div>
    <Drawer :title="$t('字段显隐')" :visible.sync="visible" size="500px" :loading="btnLoading" @confirm="submitForm" @closed="closeForm">
      <div class="choice-count-tree">
        <div class="content">
          <i class="icon el-icon-warning"></i>
          <span class="text">{{ $t('可通过拖拽字段进行排序') }}</span>
        </div>
      </div>
      <el-tree
        ref="columnTree"
        class="field-list"
        node-key="field"
        show-checkbox
        default-expand-all
        draggable
        :check-on-click-node="true"
        :data="setTableColumn"
        :props="{
          label: 'title'
        }"
        :allow-drop="allowDrop"
        @node-drop="handleDrop"
        @check="treeCheckChange"
      />
    </Drawer>
  </div>
</template>

<script>
export default {
  props: {
    setTableColumn: {
      // 勾选的列表项
      type: Array,
      default() {
        [];
      }
    },
    drawerVisible: {
      type: Boolean,
      default: false
    },
    btnLoading: {
      type: Boolean,
      default: false
    },
    isNewColour: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: this.drawerVisible
    };
  },
  watch: {
    drawerVisible(val) {
      this.visible = val;
      if (val) {
        const checkNode = this.setTableColumn.filter(item => item.visible);
        this.$nextTick(() => {
          this.$refs.columnTree.setCheckedKeys(checkNode.map(item => item.field));
        });
      }
    }
  },
  methods: {
    submitForm() {
      // 提交
      this.$emit('submitForm', this.setTableColumn);
    },
    closeForm() {
      this.$emit('closeDrawer');
    },
    treeCheckChange(data) {
      this.setTableColumn.forEach(item => {
        if (item.field === data.field) {
          item.visible = !item.visible;
        }
      });
    },
    allowDrop(draggingNode, dropNode, type) {
      return type !== 'inner';
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      this.setTableColumn.forEach(item => {
        if (item.field === draggingNode.data.field) {
          item.visible = draggingNode.data.visible;
        }
      });
      if (draggingNode.data.visible) {
        this.$refs.columnTree.setChecked(draggingNode.data.field, true, false);
      } else {
        this.$refs.columnTree.setChecked(draggingNode.data.field, false, false);
      }
    }
  }
};
</script>

<style lang="scss">
.field-list {
  .el-tree-node__content {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    .el-tree-node__expand-icon.is-leaf {
      visibility: hidden;
      color: transparent;
      cursor: default;
      height: 40px;
      position: absolute;
      left: -30px;
    }
    .el-tree-node__label {
      font-size: 14px;
      padding-left: 16px;
    }
    .el-checkbox {
      position: absolute;
      right: 0;
    }
  }
  .el-tree-node:focus > .el-tree-node__content {
    background-color: $main-hover-light;
  }
}
</style>
<style lang="scss" scoped>
.choice-count-tree {
  width: 100%;
  background: $main-hover-light;
  border: 1px solid $main-text-disabled;
  border-radius: 2px;
  margin-bottom: 16px;
  .content {
    display: flex;
    justify-content: start;
    .icon {
      padding-left: 16px;
      width: 14px;
      height: 14px;
      opacity: 1;
      line-height: 35px;
      color: $main;
    }
    .text {
      margin-left: 18px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      text-align: LEFT;
      color: rgba(0, 0, 0, 0.85);
      line-height: 35px;
    }
  }
}
::v-deep {
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: $main;
    border-color: $main;
  }
  .el-checkbox__inner:hover {
    border-color: $main;
  }
}
</style>
